import React from 'react';
import { get } from 'lodash';

import styles from './LinkedTaskField.module.scss';
import { DateField, SimpleBlock, useFormContext, Text } from 'ui-builder';
import { Image, Spacings } from 'react-native-ui-lib';
import { ImageSourcePropType } from 'react-native';

import anchorIcon from './anchorIcon.svg';

export function LinkedTaskField(
  props: {
    fieldId: number,
    // eslint-disable-next-line react/no-unused-prop-types
    linkedTask: {
      name: string,
    }
    label: string,
    testId?: string,
  },
) {
  const formContext = useFormContext();
  const data = formContext.data!;

  const value = get(data, `${props.fieldId}`);


  return (
    <SimpleBlock className={styles.widget} style={{
      flexDirection: 'row',
      gap: Spacings.s1
    }} testID={props.testId}>
      <Image source={anchorIcon as ImageSourcePropType} />
      <SimpleBlock style={{ flexDirection: 'row' }}>
        <DateField source="" value={value} noValueText="No Due Date" />
        <Text>{` (${props.linkedTask.name})`}</Text>
      </SimpleBlock>
    </SimpleBlock>
  );
}
